import { css } from '@/styled-system/css';

export const comboboxChipsOverflowStyles = css.raw({
  color: 'Combobox.ChipsOverflow.text.default',
  textStyle: 'body',
  marginInlineEnd: 'Combobox.ChipsOverflow.trailingTextArea.gap.limitNumber-toText',
});
